import type * as React from 'react';

import type { SelectOptionBaseType } from './types';

export interface OptGroupProps extends Pick<SelectOptionBaseType, 'key' | 'label'> {
  children?: React.ReactNode;
}

export interface OptionGroupFC extends React.FC<OptGroupProps> {
  isSelectOptGroup: boolean;
}

const OptGroup: OptionGroupFC = () => null;
OptGroup.isSelectOptGroup = true;

export default OptGroup;
